import { Grid } from '@mui/material';
import { useEditContext } from '@prismamedia/one-crud-react';
import { HeaderFields } from 'components/HeaderFields';
import { FC, useState } from 'react';
import { AutomationFields } from './AutomationFields';
import { ContentFields } from './ContentFields';
import { useStyles } from './styles';

const DEFAULT_CAMPAIGN_SECTION_COUNT = '1';

export const Generalities: FC = () => {
  const context = useEditContext();
  const classes = useStyles();
  const [campaignSectionCount, setCampaignSectionCount] = useState<string>(
    context.item.isFromNlf
      ? context.item.sections && JSON.parse(context.item.sections).length
      : context.item.defaultCampaignSectionCount
      ? context.item.defaultCampaignSectionCount
      : DEFAULT_CAMPAIGN_SECTION_COUNT,
  );

  return (
    <div className={classes.grid}>
      <Grid item className={classes.grid}>
        <ContentFields
          campaignSectionCount={campaignSectionCount}
          onCampaignSectionCountChange={setCampaignSectionCount}
        />
      </Grid>
      <Grid item className={classes.grid}>
        <AutomationFields campaignSectionCount={campaignSectionCount} />
      </Grid>
      <Grid item className={classes.grid}>
        <HeaderFields />
      </Grid>
    </div>
  );
};
